import React, { useMemo } from 'react';
import { Box, MenuItem, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { setActiveSocietyId } from '../app/store/contextSlice';

const SocietySelector = ({ compact = false }) => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const societies = useSelector((state) => state.context.societies);
  const activeSocietyId = useSelector((state) => state.context.activeSocietyId);

  const value = useMemo(() => activeSocietyId || '', [activeSocietyId]);

  const handleChange = (event) => {
    const nextSocietyId = event.target.value || null;

    dispatch(setActiveSocietyId(nextSocietyId));

    const nextParams = new URLSearchParams(searchParams);
    if (nextSocietyId) {
      nextParams.set('societyId', nextSocietyId);
    } else {
      nextParams.delete('societyId');
    }

    setSearchParams(nextParams, { replace: true });
  };

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: compact ? 180 : 220 },
        minWidth: 0,
      }}
    >
      <TextField
        size="small"
        select
        fullWidth
        value={value}
        onChange={handleChange}
        sx={{
          '& .MuiOutlinedInput-root': {
            height: 40,
            bgcolor: 'background.paper',
          },
        }}
      >
        <MenuItem value="">Select Society</MenuItem>
        {societies.map((society) => (
          <MenuItem key={society.id} value={society.id}>
            {society.name}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  );
};

export default SocietySelector;
